
export default function safeParse( str ) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
}